import * as React from 'react';
import { GridFilterCellProps } from '@progress/kendo-react-grid';
import './DateRange.scss';
import { DateRangePickerInput } from 'v3/Components/Form/DateTimePickers/DateRangePicker';

interface DateRangePickerFilterCellProps extends GridFilterCellProps {
  dateOnly?: boolean;
}

export const DateRangePickerFilterCell = (props: DateRangePickerFilterCellProps) => {
  const [valueString, setValueString] = React.useState<string>(props.value || '');

  React.useEffect(() => {
    setValueString(props.value || '');
  }, [props.value]);

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValueString = e.target.value;
    setValueString(newValueString);
    props.onChange({
      value: newValueString,
      operator: 'contains',
      syntheticEvent: { ...e, currentTarget: { id: `filter-${props.field}` } },
    });
  };

  return (
    <div>
      <DateRangePickerInput
        onChange={handleOnChange}
        valueString={valueString}
        dateOnly={props.dateOnly}
        isTable
        clearable
      />
    </div>
  );
};
export default DateRangePickerFilterCell;
